import { modalController } from '@ionic/vue';
import OnboardingAgree from '@/components/OnboardingAgree.vue';
import store from '@/store';

export default {
  computed: {
    user: () => store.user,
  },
  methods: {
    /**
     * Skip onboarding.
     */
    async skip() {
      await modalController.dismiss();
      const modal = await modalController.create({
        component: OnboardingAgree,
        showBackdrop: false,
        backdropDismiss: false,
      });
      await modal.present();
    },
  },
};
